import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      position: relative;\n      touch-action: none;\n      line-height: normal;\n    "])));
  },
  calendarWrapper: function calendarWrapper(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      background: ", ";\n      box-shadow: ", ";\n      display: flex;\n      flex-flow: column nowrap;\n      font-size: 0;\n      z-index: 1000;\n      touch-action: none;\n      border-radius: ", ";\n    "])), t.calendarBg, t.pickerShadow, t.calendarBorderRadius);
  }
});